export var LOG_IN_TITLE = {
  en: 'Log in'
};
export var LOG_IN_DESCRIPTION = {
  en: 'COSMOS creates, aggregates and generates data insights for the future of Sustainable Energy in Latin America. Join us!'
};
export var EMAIL_LABEL = {
  en: 'Email'
};
export var PASSWORD_LABEL = {
  en: 'Password'
};
export var CONFIRM_PASSWORD_LABEL = {
  en: 'Confirm Password'
};
export var LOG_IN_SUBMIT_LABEL = {
  en: 'Log In'
};
export var LOG_IN_SUBMITTING_LABEL = {
  en: 'Logging In...'
};
export var FORGOT_PASSWORD_LINK_TEXT = {
  en: 'Forgot Password'
};
export var STAY_SIGNED_IN_LABEL = {
  en: 'Stay Signed In'
};
export var NO_ACCOUNT_TEXT = {
  en: "Don't have an account?"
};
export var SIGN_UP_LINK_TEXT = {
  en: 'Sign Up'
};
export var FEEDBACK_MENU_LINK_MAIN_TEXT = {
  en: 'Give us'
};
export var FEEDBACK_MENU_LINK_SUBTEXT = {
  en: 'your feedback'
};
export var FEEDBACK_MENU_LINK_IMAGE_ALT_TEXT = {
  en: 'Feedback'
};
export var RESET_PASSWORD_TITLE = {
  en: 'Reset Password'
};
export var CHOOSE_PASSWORD_TITLE = {
  en: 'Choose Password'
};
export var RESET_PASSWORD_DESCRIPTION = {
  en: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
};
export var CHOOSE_PASSWORD_DESCRIPTION = {
  en: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
};
export var RESET_PASSWORD_SUBMIT_LABEL = {
  en: 'Email Reset Password Link'
};
export var RESET_PASSWORD_SUBMITTING_LABEL = {
  en: 'Emailing Reset Password Link...'
};
export var SET_PASSWORD_SUBMIT_LABEL = {
  en: 'Set Password'
};
export var SET_PASSWORD_SUBMITTING_LABEL = {
  en: 'Setting Password...'
};
export var REMEMBERED_PASSWORD_TEXT = {
  en: 'Remembered your password?'
};
export var LOG_IN_LINK_TEXT = {
  en: 'Log In'
};
export var SIGN_UP_TITLE = {
  en: 'Sign Up'
};
export var SIGN_UP_DESCRIPTION = {
  en: 'COSMOS creates, aggregates and generates data insights for the future of Sustainable Energy in Latin America. Join us!'
};
export var SIGN_UP_SUBMIT_LABEL = {
  en: 'Sign Up'
};
export var SIGN_UP_SUBMITTING_LABEL = {
  en: 'Signing Up...'
};
export var SIGN_UP_FREE_TRIAL_SUBMIT_LABEL = {
  en: 'Start your 5 Day Free Trial!'
};
export var SIGN_UP_FREE_TRIAL_SUBMITTING_LABEL = {
  en: 'Signing Up...'
};
export var ALREADY_HAVE_ACCOUNT_TEXT = {
  en: 'Already have an account?'
};
export var SET_PASSWORD_SUCCESS_MESSAGE = {
  en: 'Password set! Sign in to continue.'
};
export var SIGNUP_SUCCESS_MESSAGE = {
  en: 'Success! Please check your email.'
};
export var SIGNUP_ERROR_MESSAGE = {
  en: 'Uh oh! An error occurred.'
};
export var CONFIRM_PASSWORD_ERROR_MESSAGE = {
  en: 'Password and confirm password must be the same.'
};
export var SET_PASSWORD_ERROR_MESSAGE = {
  en: 'Uh oh! An error occurred.'
};
export var LOGIN_ERROR_MESSAGE = {
  en: 'User does not exist.'
};
export var REQUEST_RESET_PASSWORD_SUCCESS_MESSAGE = {
  en: 'Success! Please check your email.'
};
export var REQUEST_RESET_PASSWORD_ERROR_MESSAGE = {
  en: 'Uh oh! An error occurred.'
};
export var SAMPLE_RATE_HOURLY_TITLE = {
  en: 'Hourly',
  es: 'Cada hora'
};
export var SAMPLE_RATE_DAILY_TITLE = {
  en: 'Daily',
  es: 'Diario'
};
export var SAMPLE_RATE_WEEKLY_TITLE = {
  en: 'Weekly',
  es: 'Semanal'
};
export var SAMPLE_RATE_MONTHLY_TITLE = {
  en: 'Monthly',
  es: 'Mensual'
};
export var SAMPLE_RATE_YEARLY_TITLE = {
  en: 'Yearly',
  es: 'Anual'
};
export var LANGUAGE_SPANISH_NAME = {
  en: 'Spanish',
  es: 'Español'
};
export var LANGUAGE_ENGLISH_NAME = {
  en: 'English',
  es: 'Inglés'
};
export var COUNTRY_PAGE_POPULATION_PREFIX = {
  en: 'Population',
  es: 'Población'
};
export var GRAPH_SECTIONS_EMPTY_STATE_APOLOGY_TEXT = {
  en: 'Sorry, we were unable load any data for this country.'
};
export var GRAPH_SECTIONS_EMPTY_STATE_TRY_AGAIN_TEXT = {
  en: 'Click here to try again'
};
export var TIME_GRAPH_NO_GENERATORS_SELECTED_TEXT = {
  en: 'No generators selected'
};
export var PRICE_GRAPH_NO_SOURCES_SELECTED_TEXT = {
  en: 'No sources selected'
};
export var FOOTER_COPYRIGHT_TEXT = {
  en: 'Copyright © 2018 Xinampa. All Rights Reserved.'
};
export var CHECKBOX_CLEAR_BUTTON_TEXT = {
  en: 'Clear'
};
export var SELECT_SOURCES_TEXT = {
  en: 'Select Sources'
};
export var SELECT_REGIONS_TEXT = {
  en: 'Select Regions'
};
export var USE_THESE_SOURCES_BUTTON_TEXT = {
  en: 'Use these sources'
};
export var USE_THESE_REGIONS_BUTTON_TEXT = {
  en: 'Use these regions'
};
export var REGIONAL_COMPARE_NO_REGIONS_SELECTED_TEXT = {
  en: 'No regions selected'
};
export var REGIONAL_COMPARE_REGION_CHECKBOX_LIST_TITLE = {
  en: 'Regions'
};
export var FEEDBACK_MENU_ERROR_MESSAGE = {
  en: 'We experienced an error'
};
export var FEEDBACK_MENU_SUBMIT_ERROR_MESSAGE = {
  en: 'We experienced an error submitting your feedback. Please try again.'
};
export var DOWNLOAD_DATA_DATE_RANGE_LABEL = {
  en: 'Download data for'
};
export var COSMOS_DATE_RANGE_CONNECTING_LABEL = {
  en: 'to',
  es: 'a'
};
export var FOUR_OH_FOUR_PAGE_MESSAGE = {
  en: 'We experienced an error. Please try again.'
};
export var SIGN_UP_PAGE_PARAM_TITLE_FIRST_NAME = {
  en: 'First Name',
  es: 'Nombre'
};
export var SIGN_UP_PAGE_PARAM_TITLE_LAST_NAME = {
  en: 'Last Name',
  es: 'Apellidos'
};
export var SIGN_UP_PAGE_PARAM_TITLE_EMAIL = {
  en: 'Email'
};
export var SIGN_UP_PAGE_PARAM_TITLE_INSTITUTION_NAME = {
  en: 'Institution Name'
};
export var SIGN_UP_PAGE_PARAM_TITLE_INSTITUTION_TYPE = {
  en: 'Institution Type'
};
export var SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_NOT_SELECTED = {
  en: 'Select the best that applies'
};
export var SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_LARGE_SCALE_RENEWABLE = {
  en: 'Large Scale Renewable energy provider (e.g., solar, wind)'
};
export var SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_SMALL_SCALE_RENEWABLE = {
  en: 'Small Scale Sustainable Energy Provider (e.g., rooftop solar, microloans for energy efficiency, energy auditor)'
};
export var SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_LARGE_SCALE_EFFICIENCY = {
  en: 'Large Scale Energy Efficiency Company'
};
export var SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_ELECTRIC_UTILITY = {
  en: 'Electric Utility'
};
export var SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_UNIVERSITY = {
  en: 'University'
};
export var SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_CONSULTING_COMPANY = {
  en: 'Consulting Company'
};
export var SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_LOCAL_GOVERNMENT_THINK_TANK = {
  en: 'Local Government Think Tank'
};
export var SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_SMART_GRID_SERVICES = {
  en: 'Smart Grid Services (e.g., batteries, demand response)'
};
export var SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_SMART_GRID_ANALYTICS = {
  en: 'Smart Grid Analytics (e.g., data mining, machine learning)'
};
export var SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_FINANCIAL = {
  en: 'Financial Services (e.g., Bank)'
};
export var SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_DEVELOPMENT_AGENCY = {
  en: 'Development Agency (e.g., GIZ, IDB)'
};
export var SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_NON_PROFIT = {
  en: 'Non-Profit Organization'
};
export var SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_OTHER = {
  en: 'Other'
};